<tt-card ttClass="flex-column flex-1 height-full">
    <h3 class="tt-card__heading" style="flex: 0 0 auto">{{ get?.docpacktypechapter_name ?? " " }}</h3>

    <tt-tabs #tabs>
        <tt-tab ttId="DOCUMENTS" ttLabel="gb_docpack_documents_documents"></tt-tab>
        <tt-tab ttId="FRONTPAGE" ttLabel="gb_docpack_documents_frontpage"></tt-tab>
    </tt-tabs>
    <ng-container *ngIf="!!get">
        <tt-divider [hidden]="tabs.ttSelectedId !== 'DOCUMENTS'">
            <tt-divider-columns>
                <tt-divider-pane>
                    <tt-grid
                        *ngIf="!!chapterDocumentsGrid"
                        [(ttOptions)]="chapterDocumentsGrid"
                        ttRowSelection="single"
                        (ttOnRead)="onChapterDocumentsGridRead()"
                        (ttOnRowSelected)="onRowSelected($event)"
                    ></tt-grid>
                </tt-divider-pane>
                <tt-divider-pane *ngIf="!!selectedDocument || selectedDocumentLoading">
                    <div class="doc-pack-document-preview">
                        <div *ngIf="selectedDocumentRotatable" class="doc-pack-document-preview__toolbar">
                            <tt-button ttIcon="fas fa-undo" ttText="rotate_left" [ttDisabled]="selectedDocumentLoading || rotatingDocument" (ttClick)="rotateSelectedDocument(-90)"></tt-button>
                            <tt-button
                                ttIcon="fas fa-redo"
                                ttText="rotate_right"
                                ttIconAlign="left"
                                [ttDisabled]="selectedDocumentLoading || rotatingDocument"
                                (ttClick)="rotateSelectedDocument(90)"
                            ></tt-button>
                        </div>
                        <div class="doc-pack-document-preview__document">
                            <div *ngIf="selectedDocumentLoading" class="col-xs-12 sp-0 tt-skeleton flex-1" style="display: block; height: 100%"></div>
                            <img
                                *ngIf="!selectedDocumentLoading && selectedDocumentIsImage && selectedDocumentImageSrc"
                                class="doc-pack-document-preview__image"
                                decoding="async"
                                [src]="selectedDocumentImageSrc"
                                [style.transform]="'rotate(' + selectedDocumentRotation + 'deg)'"
                            />
                            <iframe
                                *ngIf="!selectedDocumentLoading && selectedDocumentRotatable && !selectedDocumentIsImage && selectedDocumentPreviewSrc"
                                class="doc-pack-document-preview__iframe"
                                [src]="selectedDocumentPreviewSrc"
                            ></iframe>
                            <tt-document-viewer-legacy
                                *ngIf="!selectedDocumentLoading && !selectedDocumentRotatable"
                                style="display: block; height: 100%"
                                [ttModel]="selectedDocument"
                            ></tt-document-viewer-legacy>
                        </div>
                    </div>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
        <div *ngIf="tabs.ttSelectedId === 'FRONTPAGE'" class="flex-column height-full flex-1">
            <div>
                <tt-button-save class="col-xs-12 col-md-4 sp-5" ttText="docpack_docpackchapter_save" (ttClick)="save()" [ttLoading]="saving" [ttDisabled]="htmlProcessing"></tt-button-save>
                <tt-button class="col-xs-12 col-md-4 sp-5" ttText="docpack_docpackchapter_html_update" ttIcon="fas fa-sync-alt" (ttClick)="reset()" [ttLoading]="resetting"></tt-button>
            </div>
            <tt-editor
                class="flex-1"
                ttLabel="html_text_frontpage"
                [ttEditorCss]="styling?.additional_styling ?? ''"
                [(ttModel)]="get.html_text"
                [(ttProcessing)]="htmlProcessing"
                ttHeight="100%"
            ></tt-editor>
        </div>
    </ng-container>
    <ng-container *ngIf="!get">
        <div class="col-xs-12 sp-0">
            <div class="col-xs-12 col-md-4 sp-5">
                <div class="tt-skeleton" style="height: var(--tt-height); background-color: var(--tt-success-color); margin-bottom: 7px"></div>
            </div>
            <div class="col-xs-12 col-md-4 sp-5">
                <div class="tt-skeleton" style="height: var(--tt-height); background-color: var(--tt-primary-color); margin-bottom: 7px"></div>
            </div>
        </div>
        <div class="col-xs-4 sp-0 tt-skeleton" style="width: 40%; height: var(--tt-font-size-sm); margin-bottom: 4px"></div>
        <div class="col-xs-12 sp-0 tt-skeleton flex-1" style="height: 20rem; margin-bottom: 7px"></div>
    </ng-container>
</tt-card>
